import React from "react";
// reactstrap components
import {
  Row,
  Col,
  Button
} from "reactstrap";

class Step2 extends React.Component {

  render() {

    const {
      reportType
    } = this.props;

    return (
      <>
        <h5 className="info-text">
          Now let's set the parameters
        </h5>
        <Row className="justify-content-center mt-5">
          {reportType && reportType.value === "unitCost" 
            ? <Col sm="10">
                <p className="my-3">Unit Cost report parameters retrieved from the "Yarly Indicators" table.</p>
                <p className="my-3">Make sure they are saved correctly and are up to date.</p>
              </Col>
            : <Col sm="10">
                <p>There are no filters applicable for this report.</p>
                <p>Please proceed to the next step.</p>
              </Col>
          }
            
          
        </Row>
        <Row className="d-flex justify-content-lg-around mt-3">
            <Button 
                onClick={this.props.previousStep}
                disabled={!this.props.previousStep}
            >
                Previous Step
            </Button>
            <Button 
                onClick={this.props.nextStep}
                disabled={!this.props.nextStep}
            >
                Next Step
            </Button>
        </Row>
      </>
    );
  }
}

export default Step2;
